import { render, staticRenderFns } from "./hotelStock.vue?vue&type=template&id=31cd0482&scoped=true"
import script from "./hotelStock.vue?vue&type=script&lang=js"
export * from "./hotelStock.vue?vue&type=script&lang=js"
import style0 from "./hotelStock.vue?vue&type=style&index=0&id=31cd0482&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cd0482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31cd0482')) {
      api.createRecord('31cd0482', component.options)
    } else {
      api.reload('31cd0482', component.options)
    }
    module.hot.accept("./hotelStock.vue?vue&type=template&id=31cd0482&scoped=true", function () {
      api.rerender('31cd0482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/hotelStock.vue"
export default component.exports